
// src/connects/settings-page.js

import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import ui from '../helpers/ui-state'
import lifecycle from '../helpers/lifecycle'
import actions from '../actions'
import combineHOC from '../helpers/combine-hoc'

export const mapStateToProps = (state)=> {
  return {
    isPhone: state.media.isPhone,
    message: state.alertMessage.message,
    category: state.alertMessage.category,
  }
}

export const mapDispatchToProps = (dispatch, ownProps)=> {
  return {
    onCloseDrawer: ()=> ownProps.updateUI({ active: false }),
    onOpenDrawer: ()=> ownProps.updateUI({ active: true }),
    clearAlertMessage: ()=> dispatch(actions.clearAlertMessage()),
    selectPanel: (name, subName, params)=> ownProps.updateUI({ name, subName, params }),

    willUpdate: (props, nextProps)=> {
      if (nextProps.name && props.name != nextProps.name) {
        ownProps.updateUI({ name: nextProps.name })
      }
    },
  }
}

export default combineHOC(
  ui({
    state: {
      active: false,
      name: (props)=> props.initialName,
      subName: undefined,
      params: undefined,
    },
    exports: true,
  }),
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle,
  translate(),
)



// WEBPACK FOOTER //
// ./src/connects/settings-page.js